import {ArenaGameFilterEditor} from "../filters/arena-game-filter-editor";
import {IArenaGameFiltersCategoryEditorViewModel} from "./arena-game-filters-category-editor-view-model.interface";
import {IArenaGameFiltersCategory} from "./arena-game-filters-category.interface";
import { computed, makeObservable } from "mobx";
import {NullableNumber} from "../../../../../common/types/nullable-types";
import {IArenaGameFilterEditorViewModel} from "../filters/arena-game-filter-editor-view-model.interface";
import {CategoryDefinitionId} from "../../filters-categories-definitions/filter-category-definition.interface";

export class ArenaGameFiltersCategoryEditor implements IArenaGameFiltersCategoryEditorViewModel {
    constructor(private readonly arenaGameFilterCategory: IArenaGameFiltersCategory) {
        makeObservable(this);

        this._filters = arenaGameFilterCategory.availableFilters.map(f => new ArenaGameFilterEditor(f, this));
    }

    private readonly _filters: ArenaGameFilterEditor[];
    @computed
    get visibleFilters(): ArenaGameFilterEditor[] {
        return this._filters.filter(f => f.shouldBeDisplayed);
    }

    get id(): CategoryDefinitionId {
        return this.arenaGameFilterCategory.id;
    }

    get title(): string {
        return this.arenaGameFilterCategory.title;
    }

    getAppliedFiltersIds(): string[] {
        return this._getAllAppliedFilters().map(f => f.id);
    }

    get gamesCount(): NullableNumber {
        return this.arenaGameFilterCategory.gamesCount;
    }

    get isMultiSelect(): boolean {
        return this.arenaGameFilterCategory.isMultiSelect;
    }

    private _getAllAppliedFilters(): ArenaGameFilterEditor[] {
        const result: ArenaGameFilterEditor[] = [];

        for(let filter of this._filters) {
            if(filter.on) {
                result.push(filter);
                for(let subFilter of filter.subFilters) {
                    if(subFilter.on) {
                        result.push(subFilter)
                    }
                }
            }
        }
        return result;
    }


    getVisibleAppliedFilters(): IArenaGameFilterEditorViewModel[] {
        return this._getAllAppliedFilters().filter(f => f.shouldBeDisplayed);
    }

}